export default {
  data() {
    return {
      metaData: [],
      linkData: [],
      mixin_description: '',
      mixin_title: 'Digitl GmbH'
    }
  },
  computed: {
    metaFields() {
      return this.metaData
    },
    linkFields() {
      return this.linkData
    },
    metaTitle() {
      return this.mixin_title
    }
  },
  methods: {
    setHeadFields(data) {
      Object.keys(data.content).forEach((key) => {
        let val = data.content[key]
        if (key == 'title') {
          this.mixin_title = val
        } else if (key == 'description') {
          this.metaData.push({
            hid: key,
            name: key,
            content: val
          })
        } else if (key.includes('og_')) {
          this.metaData.push({
            property: key.replaceAll('_', ':'),
            content: val
          })
        } else if (key == 'canonical') {
          this.metaData.push({
            rel: key,
            href: val
          })
        } else {
          this.metaData.push({
            property: key,
            content: val
          })
        }
      })
    }
  }
}
